import AddButton from '../authorised/impressionFinding/exam/findingActions/AddButton';

export default function Textarea(props) {
  const { input, disabled, placeholder, wrapperClasses, label, readOnly, meta: { touched, error, warning }, rows, cols, findingAutoComplete, handleOnAddFindings, FindingAutoCompleteComp, findingDropdownProps, findingWrapperClasses } = props

  return (
    <div className={`${disabled && 'disabled'} ${wrapperClasses}`}>
      {label !== undefined && <label>{props.label}</label>}
      <div className={`${findingAutoComplete && 'd-flex'}`}>
        <textarea rows={rows} cols={cols} {...input} className={`${props.className} ${touched && error && 'is-invalid'}`} disabled={props.disabled || false} placeholder={placeholder} readOnly={readOnly} />
        {findingAutoComplete && <AddButton name={input.name} value={input.value} handleOnAddFindings={handleOnAddFindings} isHeaderModule={props.isHeaderModule} />}
      </div>
      {FindingAutoCompleteComp && <div className={`${findingWrapperClasses}`}>
        <FindingAutoCompleteComp {...findingDropdownProps} />
      </div>}
      {touched &&
        ((error && <span className="invalid-feedback text-danger d-inline">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  )
}
